// /home/ronaldo/Domus/residente/residente-app/src/features/invitation/components/InvitationSuccess.tsx

import React from "react";
import { Box, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/CheckCircleOutline";
import { useNavigate } from "react-router-dom";

export const InvitationSuccess: React.FC = () => {
  return (
    <Box sx={{ textAlign: "center", py: 4 }}>
      <Box
        component="img"
        src="/images/DomusDesktop.png"
        alt="Domus logo"
        sx={{
          width: { xs: 200, sm: 250 },
          height: "auto",
          marginTop: 5,
          marginBottom: 6,
          display: "block",
          mx: "auto",
        }}
      />

      <CheckIcon
        sx={{
          fontSize: 60,
          color: "#4caf50",
          mb: 3,
        }}
      />

      <Typography variant="h5" fontWeight={600} color="#000000" mb={1}>
        ¡Visita registrada!
      </Typography>

      <Typography variant="body1" color="#666666" mb={4} px={3}>
        La invitación ha sido aceptada exitosamente. El visitante ya puede ingresar al
        edificio.
      </Typography>
    </Box>
  );
};
